export default (number, round = 0) => {
    const vNumber = Number(number)

    if (isNaN(vNumber)) return ''

    if (Number.isInteger(number)) return number

    return vNumber.toFixed(round)
}